import { render, staticRenderFns } from "./publicWelfare.vue?vue&type=template&id=3cd72247&scoped=true"
import script from "./publicWelfare.vue?vue&type=script&lang=js"
export * from "./publicWelfare.vue?vue&type=script&lang=js"
import style0 from "./publicWelfare.vue?vue&type=style&index=0&id=3cd72247&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd72247",
  null
  
)

export default component.exports